





















import { SfLoader, SfHeading, SfBreadcrumbs } from '@storefront-ui/vue';
import {
  defineComponent,
  ref,
  useFetch,
  useContext,
  computed
} from '@nuxtjs/composition-api';
import { useCache, CacheTagPrefix } from '@wemade-vsf/cache';
import { useCmsContent } from '@wemade-vsf/composables'
import type { CmsPage } from '@wemade-vsf/magento-api'
import { usePageStore, getMetaInfo } from '@wemade-vsf/core';
import CmsContent from 'components/theme/Content/CmsContent.vue';


export default defineComponent({
  name: 'CmsPage',
  components: {
    CmsContent,
    SfLoader,
    SfHeading,
    SfBreadcrumbs
  },
  setup() {
    const { routeData } = usePageStore();
    const { addTags } = useCache();
    const { error: nuxtError, localeRoute, i18n } = useContext();
    const {
      loadPage,
      loading,
      error,
    } = useCmsContent();

    const page = ref<CmsPage | null>(null);
    const breadcrumbs = ref<Array<{text: string, link: string}>|null>(null)
    const pageClasses = computed(() => page.value?.page_layout || '')

    useFetch(async () => {
      page.value = await loadPage({ identifier: routeData.identifier });

      if (error?.value?.page || !page.value) nuxtError({ statusCode: 404 });
      breadcrumbs.value = [
        { text: i18n.t('Home'), link: localeRoute({ name: 'home'}).fullPath },
        { text: page.value.content_heading ? page.value.content_heading : page.value.title, link: '' }
      ]
      addTags([{ prefix: CacheTagPrefix.View, value: routeData.identifier }]);
    });
    return {
      page,
      loading,
      pageClasses,
      breadcrumbs
    };
  },
  head() {
    const meta = getMetaInfo(this.page);
    return {
      ...meta,
      bodyAttrs: {
        class: `cms-page ${this.page ? this.page['identifier'] : ''} ${this.pageClasses}`
      }
    }
  },
});
